import React from 'react';

import { components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';

import { truncateWithElipsis } from 'src/lib/text';

import GenericAsyncSelect from 'src/views/components/select/GenericAsyncSelect';

const Option = ({ data, ...props }) => {
  return (
    <components.Option {...props} data={data}>
      <div>{data.label}</div>
      <div style={{ fontSize: token('font.size.075', '12px'), marginLeft: '1em' }}>{truncateWithElipsis(data.description || '', 200)}</div>
    </components.Option>
  );
};

const PdIncidentWorkflowTriggerSelect = ({ optionSources, errorComponent, ...props }) => {
  return (
    <GenericAsyncSelect
      components={{ Option }}
      options={optionSources}
      errorComponent={errorComponent}
      {...props}
    />
  );
};

export default PdIncidentWorkflowTriggerSelect;
